<template>
  <RemotePaginatedList hide-search
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       data-url="aafb/coupon/"
                       data-key="coupons"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.create_at="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.item_type="{item}">
      {{ getCouponType(item) }}
    </template>
    <template v-slot:item.valid_until="{value}">
      {{ $parseDate(value) }}
    </template>
    <template v-slot:item.used_on="{item}">
      {{ getCouponUsedOn(item) }}
    </template>
  </RemotePaginatedList>
</template>

<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList.vue";

export default {
  name: 'CouponList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return []
    })

    // Data Table
    const headers = ref([
      {text: root.$t('coupon.create_at'), value: 'create_at'},
      {text: root.$t('coupon.amount'), value: 'amount'},
      {text: root.$t('coupon.item_type'), value: 'item_type', sortable: false},
      {text: root.$t('coupon.valid_until'), value: 'valid_until'},
      {text: root.$t('coupon.used_at'), value: 'used_on', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const getCouponType = function (coupon) {
      if (coupon.item_type) return coupon.item_type.name;
      if (coupon.gym_pass_type) return `${root.$t('gym_subscription.title')} - ${coupon.gym_pass_type.name}`;
    }

    const getCouponUsedOn = function (coupon) {
      if (coupon.used_on_booking) return `${root.$parseDate(coupon.used_on_booking.start_time, 'yyyy-MM-dd HH:mm')} - ${root.$parseDate(coupon.used_on_booking.end_time, 'HH:mm')} ${coupon.used_on_booking.item.name}`;
      if (coupon.used_on_gym_subscription) return `${root.$parseDate(coupon.used_on_gym_subscription.create_at, 'yyyy-MM-dd HH:mm')} - ${"GYM" + coupon.used_on_gym_subscription.reference_number.toString().padStart(8, '0')}`;
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      getCouponType,
      getCouponUsedOn,
    }
  }
}
</script>
